import { IDoctor } from "../../interfaces/api";

const SimpleDoctorTile = ({
  data,
  onRemove,
}: {
  data: IDoctor;
  onRemove: (providerId: string, npi: string, provider: boolean) => void;
}) => {
  const nearestLocation = data.ahRecords.map((record) => ({
    ...record,
    addresses: [...record.addresses]
      .filter((address) => address.visitType === "Office")
      .sort((a, b) => a.distanceFromGivenAddress - b.distanceFromGivenAddress),
  }));
  const nearestFromAllLocations = nearestLocation.sort(
    (a, b) =>
      a.addresses[0].distanceFromGivenAddress -
      b.addresses[0].distanceFromGivenAddress
  );

  const minDistanceLocation =
    nearestFromAllLocations.length > 0
      ? nearestFromAllLocations[0].addresses[0]
      : null;

  const hasVirtual = data.ahRecords.some((record) =>
    record.addresses.some((address) => address.visitType === "Virtual")
  );

  const isProvider =
    data.ahRecords[0].providerCategory[0] === "Primary Care Provider (PCP)";

  return (
    <div
      style={{
        border: "1px solid #1B54C2",
        width: " 100%",
        justifyContent: "space-between",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "16px" }}>
        <div style={{ display: "flex", alignContent: "center" }}>
          <div style={{ width: 30 }}>
            <img
              src={
                (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
                "/DoctorItem.png"
              }
              alt="Vector"
            />
          </div>

          <h3
            className="secondary-color"
            style={{
              fontSize: "22px",
              paddingTop: 6,
              paddingBottom: "16px",
              paddingLeft: 8,
            }}
          >
            {data.nppes.firstName} {data.nppes.lastName}, {data.nppes.suffix}
          </h3>
        </div>
        <div style={{ paddingBottom: "6px", textAlign: "left" }}>
          <span style={{ fontWeight: 600 }}>NPI:</span> {data.npi}
        </div>
        <div style={{ paddingBottom: "6px", textAlign: "left" }}>
          <span style={{ fontWeight: 600 }}>Speciality:</span>{" "}
          {data.specialities[0].desc}
        </div>
        <div style={{ textAlign: "left" }}>
          <span style={{ fontWeight: 600 }}>Nearest location:</span>{" "}
          {minDistanceLocation?.standardized.address1}
          {!!minDistanceLocation?.standardized.address2
            ? ` ${minDistanceLocation.standardized.address2}, `
            : ", "}
          {minDistanceLocation?.standardized.city},{" "}
          {minDistanceLocation?.standardized.state}{" "}
          {minDistanceLocation?.standardized.zip5}
          {hasVirtual ? ", but this PCP offers virtual visits" : ""}
        </div>
      </div>
      <div
        className="primary-color"
        style={{
          backgroundColor: "#F5F9FD",
          padding: "4px",
          display: "flex",
          columnGap: "28px",
          justifyContent: "flex-end",
        }}
      >
        <button
          type="button"
          className="text-underline primary-color"
          style={{ cursor: "pointer", padding: "16px 24px 16px 0" }}
          onClick={() =>
            onRemove(data.ahRecords[0].providerID, data.npi, isProvider)
          }
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default SimpleDoctorTile;
